import { CanDeactivateFn } from "@angular/router"
import { ManageStudentSubscriptionsComponent } from "./manage-student-subscriptions.component"

export const canDeactivateManageStudentSubscriptions: CanDeactivateFn<ManageStudentSubscriptionsComponent> = (component: ManageStudentSubscriptionsComponent) =>
  {
    const diff = component.subscriptionDiff();
    return (diff.add.length > 0 || diff.remove.length > 0) ? confirm("You have unsaved changes. Are you sure you want leave?") : true
  }
